import React from 'react';

import {
    MsalAuthProvider,
    LoginType,
    AuthenticationState
} from 'react-aad-msal';

import config from '../../config.json';

// Authentication Parameters
const authenticationParameters = {
    scopes: [`api://${config.msal.auth.clientId}/user_impersonation`],
}

// Options
const options = {
    loginType: LoginType.Redirect
}

export const msalAuthProvider = new MsalAuthProvider(config.msal, authenticationParameters, options)

export const AuthContext = React.createContext(null);

const { Provider } = AuthContext;
export const AuthProvider = (props) => {

    const getTokenAsync = async () => {
        const token = await msalAuthProvider.getAccessToken();
        return token.accessToken;
    }

    const isAuthenticated = () => {
        return msalAuthProvider.authenticationState == AuthenticationState.Authenticated;
    }

    const getAccountInfo = () => {
        if (!isAuthenticated()) return null;
        const accountInfo = msalAuthProvider.getAccountInfo();
        //console.debug(accountInfo);
        return accountInfo.account;
    }

    const logOut = () => {
        msalAuthProvider.logout();
    }

    return (
        <Provider value={{
            getTokenAsync,
            isAuthenticated,
            getAccountInfo,
            logOut,
        }}>
            {props.children}
        </Provider>
    );
}